module.exports = {
  siteTitle: 'Vidya Bhandary | Solution Architect, Presales Engineer and Avid Technologist',
  siteDescription:
    'Vidya Bhandary is a Technical Presales Engineer, Solution Architect, Python Developer, Cloud Computing, Data Science and Gen AI Enthusiast ',
  siteKeywords:
    'Vidya Bhandary, Vidya, Bhandary, vidyabhandary, software engineer, data science engineer, python developer, Cloud computing, Solution Architect',
  siteUrl: 'https://vidyabhandary.github.io/',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'G-8L61S8ER6Y',
  googleVerification: '-qWOB-95GZktzUxCQWIN2_haRlm01c3OOQD1IAq15T8',

  name: 'Vidya Bhandary',
  location: 'India',
  email: 'vidya.ga@gmail.com',
  github: 'https://github.com/vidyabhandary/',
  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://in.linkedin.com/in/vidyabhandary',
    },
    {
      name: 'Github',
      url: 'https://github.com/vidyabhandary/',
    },
    // {
    //   name: 'Instagram',
    //   url: 'https://www.instagram.com/vidya_bhandary/',
    // },
    // {
    //   name: 'Twitter',
    //   url: 'https://twitter.com/vidya_bhandary',
    // },
    {
      name: 'Kaggle',
      url: 'https://kaggle.com/vidyabhandary',
    },
    {
      name: 'Medium',
      url: 'https://vidyabhandary.medium.com',
    },
    {
      name: 'YourAcclaim',
      url: 'https://www.youracclaim.com/users/vidya-bhandary/badges',
    },
    {
      name: 'DevTo',
      url: 'https://dev.to/vidyabhandary',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '#about',
    },
    {
      name: 'Experience',
      url: '#jobs',
    },
    {
      name: 'Work',
      url: '#projects',
    },
    {
      name: 'Contact',
      url: '#contact',
    },
  ],

  twitterHandle: '@vidya_bhandary',

  navHeight: 100,

  greenColor: '#64ffda',
  navyColor: '#0a192f',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
